export function roundToNthNearestMinute(date, n) {
  var coeff = 1000 * 60 * n;
  return new Date(Math.floor(new Date(date).getTime() / coeff) * coeff);
}